import React, { memo } from 'react';
import { GiftIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Psicologia della Motivazione Musicale',
    desc: "Strategie semplici per mantenere alta l'attenzione degli studenti e aumentare il loro desiderio di imparare.",
    value: '12,99 €'
  }, {
    num: 2,
    title: 'Sistema di Progresso',
    desc: 'Un metodo concreto per monitorare miglioramenti, risultati e piccoli successi lezione dopo lezione.',
    value: '9,99 €'
  }, {
    num: 3,
    title: 'Attività e Dinamiche per Insegnanti di Musica',
    desc: 'Esercizi, giochi e attività per rendere ogni lezione più viva, pratica e memorabile.',
    value: '14,99 €'
  }, {
    num: 4,
    title: 'Il Metodo del Professore',
    desc: 'La risorsa completa per insegnare con più sicurezza, più metodo e più impatto educativo.',
    value: '12,99 €'
  }];
  return <section className="py-16 md:py-24 px-4 bg-blue-900 text-white" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-23">
            E in più, oggi ricevi anche 4 Bonus Gratuiti
          </h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto" data-id="element-24">
            Strumenti extra pensati per aiutarti ad applicare tutto più
            velocemente e con risultati ancora migliori.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-25">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-xl overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-blue-500/20 transition-all transform hover:-translate-y-1 relative" onClick={scrollToOffer} data-id="element-26">
              <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-xs font-bold text-center py-1.5 uppercase tracking-wider z-10" data-id="element-27">
                GRATIS per oggi
              </div>

              <div className="p-6 pt-12 flex flex-col justify-center" data-id="element-28">
                <div className="flex items-center gap-2 mb-3" data-id="element-29">
                  <GiftIcon className="w-5 h-5 text-orange-500" data-id="element-30" />
                  <span className="text-orange-500 font-bold text-sm uppercase tracking-wider" data-id="element-31">
                    Bonus {bonus.num}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-33">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 flex-wrap" data-id="element-34">
                  <span className="text-gray-400 line-through text-sm" data-id="element-35">
                    Valore: {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-36">
                    — Oggi GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-800/50 border border-blue-700 rounded-xl p-6 text-center max-w-3xl mx-auto mb-10" data-id="element-37">
          <p className="text-xl md:text-2xl font-semibold" data-id="element-38">
            🎁 In totale riceverai 9 risorse complete per migliorare davvero il
            tuo modo di insegnare musica
          </p>
        </div>

        <div className="text-center" data-id="element-39">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white rounded-full py-5 px-10 font-bold text-xl shadow-lg shadow-orange-500/30 transition-all transform hover:scale-105" data-id="element-40">
            Voglio Tutto il Pacchetto
          </button>
        </div>
      </div>
    </section>;
}